import { Observable } from 'rxjs';
import type { Policy, PolicyRole } from '../models/policy.model';

/**
 * Stable domain contract for policy-definition CRUD.
 * Implemented by AdessoPolicyApiAdapter against the adesso-connector-api.
 */
export abstract class PolicyApiPort {
  abstract getPolicies(): Observable<Policy[]>;
  abstract sendPolicy(policy: Policy, role?: PolicyRole): Observable<{ policyId: string }>;
  abstract updatePolicy(id: string, policy: Policy, role?: PolicyRole): Observable<void>;
  abstract deletePolicy(id: string): Observable<void>;
}
